'use client';
import { ReactNode, useEffect } from 'react';

import { useHeaders } from '@hooks';

interface AppWrapperProps {
  children: ReactNode;
}

export const AppWrapper = ({ children }: AppWrapperProps) => {
  const { utmCode, handleSetUtmCode } = useHeaders();

  useEffect(() => {
    if (typeof window === 'undefined') return null;

    const getUtmCampaign = () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const utmParam = params.get('utm_campaign');
      return utmParam ? decodeURIComponent(utmParam.split('&')[0]) : null;
    };

    const urlContent = getUtmCampaign();

    if (urlContent && urlContent !== utmCode) {
      handleSetUtmCode(urlContent);

      if (window.location.pathname === '/lac') return;
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utmCode]);

  return children;
};
